import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import AdminTable from "../Administrator/Helpers/AdminTable";
import {
  editTraining,
  getAbonementsClient,
  getClientTrainings,
  getClientsList,
} from "src/store/Slices/ClientsSlice";
import { formateDate } from "src/components/helpers/formateDate";
import EditTrainingModal from "./Modals/EditTrainingModal";
import DeleteTraningModal from "./Modals/DeleteTraningModal";
import { cilMinus } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CButton } from "@coreui/react";

const ClientsTrainingNew = ({
  clientInfo,
  title,
  page,
  setPage,
  pageSize,
  setPageSize,
  isActive,
  mnemo,
}) => {
  const dispatch = useDispatch();

  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenAddEditModal(true);
      },
      disabled: !mnemo?.children
        ?.find((el) => el.name === "Таблица тренировок")
        ?.children.find((ele) => ele.mnemo === "updateBtn"),
    },
  ];

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false);
  const [trainingInfo, setIsTrainingInfo] = useState();

  // STORE
  const getClientTrainingsList = useSelector(
    (state) => state.ClientsSlice.getClientTrainingsList
  );
  const getClientTrainingsListLoading = useSelector(
    (state) => state.ClientsSlice.getClientTrainingsListLoading
  );

  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "id") {
            formattedItems["idFrom"] = values[index][0];
            formattedItems["idTo"] = values[index][1];
          } else if (key === "startDate") {
            formattedItems["StartDateFrom"] = values[index][0];
            formattedItems["StartDateTo"] = values[index][1];
          } else if (key === "endDate") {
            formattedItems["EndDateFrom"] = values[index][0];
            formattedItems["EndDateTo"] = values[index][1];
          } else if (key === "trainingsLeft") {
            formattedItems["LeftFrom"] = values[index][0];
            formattedItems["LeftTo"] = values[index][1];
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      getClientTrainings({
        clientId: clientInfo.id,
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        isActive: isActive,
        ...payload,
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onClickRowOne = (record) => {
    setIsTrainingInfo(record);
  };

  const handleMinusTraining = () => {
    setIsOpenDeleteModal(true);
  };

  const formatedClientsAbonementsRows =
    getClientTrainingsList?.data?.value?.rows.map((element) => {
      return {
        ...element,
        isPersonal: element.isPersonal ? "Да" : "Нет",
        startDate: element.startDate && formateDate(element.startDate),
        endDate: element.endDate && formateDate(element.endDate),
        abonementRegistrationDate:
          element.abonementRegistrationDate
          && formateDate(element.endDate),
        trainingsLeft:
          element.trainingsLeft > 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {" "}
              <span>{element.trainingsLeft}</span>{" "}
              <CButton
                onClick={() => handleMinusTraining(element)}
                style={{ padding: "2px 6px" }}
              >
                <CIcon
                  icon={cilMinus}
                  style={{ color: "white", fill: "white", stroke: "white" }}
                />
              </CButton>
            </div>
          ) : (
            element.trainingsLeft
          ),
      };
    });

  return (
    <>
      <EditTrainingModal
        visible={isOpenAddEditModal}
        setVisible={setIsOpenAddEditModal}
        trainingInfo={trainingInfo}
        clientInfo={clientInfo}
      />
      <DeleteTraningModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        trainingInfo={trainingInfo}
        clientInfo={clientInfo}
      />
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={getClientTrainingsListLoading}
          onClickRowOne={onClickRowOne}
          columns={getClientTrainingsList}
          rows={formatedClientsAbonementsRows}
          total={getClientTrainingsList?.data?.value?.totalCount}
          title={title}
          items={items}
        />
      )}
    </>
  );
};

export default ClientsTrainingNew;
